(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vdg-bundle-widget"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-vdg-bundle]').forEach(function(root){
  const cfg = {
    currentVariantId: parseInt(root.dataset.variantId, 10),
    basePrice: parseFloat(root.dataset.basePrice),
    tier2Price: parseFloat(root.dataset.tier2Price),
    tier3Price: parseFloat(root.dataset.tier3Price)
  };

  const tiers = [
    {min:1, unitPrice: cfg.basePrice},
    {min:2, unitPrice: cfg.tier2Price},
    {min:3, unitPrice: cfg.tier3Price}
  ];

  const tiles = Array.from(root.querySelectorAll('[data-vdg-flavor]'));
  const state = {}; // { variantId: qty }
  tiles.forEach(t => state[t.dataset.variantId] = 0);
  let mode = 'single';

  const singleCard = root.querySelector('[data-vdg-single-card]');
  const bundleCard = root.querySelector('[data-vdg-bundle-card]');
  const radioSingle = root.querySelector('[data-vdg-radio-single]');
  const radioBundle = root.querySelector('[data-vdg-radio-bundle]');
  const tierLabel = root.querySelector('[data-vdg-tier-label]');
  const tierBar = root.querySelector('[data-vdg-tier-bar]');
  const tierCount = root.querySelector('[data-vdg-tier-count]');
  const summary = root.querySelector('[data-vdg-summary]');
  const strikeEl = root.querySelector('[data-vdg-strike]');
  const finalEl = root.querySelector('[data-vdg-final]');
  const addBtn = root.querySelector('[data-vdg-add-btn]');
  const addBtnLabel = root.querySelector('[data-vdg-add-btn-label]');
  const errorEl = root.querySelector('[data-vdg-error]');

  function formatMoney(n){
    // Basic USD formatting fallback — replace with your theme's money filter output
    // via a data attribute if you support multi-currency.
    return '$' + n.toFixed(2);
  }

  function totalQty(){
    return Object.values(state).reduce((a,b)=>a+b,0);
  }
  function currentTier(q){
    return tiers.filter(t => q >= t.min).sort((a,b)=>b.min-a.min)[0];
  }

  function selectSingle(){
    mode = 'single';
    Object.keys(state).forEach(k => state[k] = 0);
    render();
  }

  function bump(variantId, delta){
    state[variantId] = Math.max(0, (state[variantId]||0) + delta);
    if(totalQty() > 0){ mode = 'bundle'; } else { mode = 'single'; }
    render();
  }

  function render(){
    singleCard.classList.toggle('is-active', mode==='single');
    bundleCard.classList.toggle('is-active', mode==='bundle');
    radioSingle.classList.toggle('is-on', mode==='single');
    radioBundle.classList.toggle('is-on', mode==='bundle');

    tiles.forEach(tile => {
      const vid = tile.dataset.variantId;
      const qty = state[vid] || 0;
      tile.classList.toggle('has-qty', qty > 0);
      tile.querySelector('[data-vdg-qty]').textContent = qty;
    });

    const tq = totalQty();
    const tier = currentTier(tq || 1) || {unitPrice: cfg.basePrice};

    if(tq <= 1){
      tierLabel.textContent = 'Add 1 more flavor — ' + formatMoney(cfg.tier2Price) + ' each';
      tierBar.style.width = '20%';
    } else if(tq === 2){
      tierLabel.textContent = 'Add 1 more — ' + formatMoney(cfg.tier3Price) + ' each';
      tierBar.style.width = '66%';
    } else {
      tierLabel.textContent = 'Best price unlocked — ' + formatMoney(cfg.tier3Price) + ' each';
      tierBar.style.width = '100%';
    }
    tierCount.textContent = tq + (tq === 1 ? ' item' : ' items');

    summary.innerHTML = '';
    tiles.forEach(tile => {
      const vid = tile.dataset.variantId;
      const qty = state[vid] || 0;
      if(qty > 0){
        const row = document.createElement('div');
        row.style.display = 'flex';
        row.style.justifyContent = 'space-between';
        row.innerHTML = '<span>' + tile.querySelector('[data-vdg-qty]').closest('.vdg-bundle__tile').querySelector('.vdg-bundle__fname').textContent
          + ' x' + qty + '</span><span>' + formatMoney(qty * tier.unitPrice) + '</span>';
        summary.appendChild(row);
      }
    });

    strikeEl.textContent = (tier.unitPrice < cfg.basePrice && tq > 0) ? formatMoney(tq * cfg.basePrice) : '';
    finalEl.textContent = formatMoney(tq * tier.unitPrice);

    if(mode === 'single'){
      addBtnLabel.textContent = 'Add to cart · ' + formatMoney(cfg.basePrice);
      addBtn.disabled = false;
    } else {
      addBtnLabel.textContent = tq > 0 ? 'Add to cart · ' + formatMoney(tq * tier.unitPrice) : 'Select at least 1 flavor';
      addBtn.disabled = tq === 0;
    }
  }

  singleCard.addEventListener('click', selectSingle);
  root.querySelector('[data-vdg-bundle-header]').addEventListener('click', () => {
    if(mode !== 'bundle'){ mode = 'bundle'; render(); }
  });

  tiles.forEach(tile => {
    const vid = tile.dataset.variantId;
    tile.querySelector('[data-vdg-inc]').addEventListener('click', (e) => { e.stopPropagation(); bump(vid, 1); });
    tile.querySelector('[data-vdg-dec]').addEventListener('click', (e) => { e.stopPropagation(); bump(vid, -1); });
  });

  addBtn.addEventListener('click', async () => {
    errorEl.hidden = true;
    addBtn.disabled = true;
    const originalLabel = addBtnLabel.textContent;
    addBtnLabel.textContent = 'Adding…';

    let items;
    if(mode === 'single'){
      items = [{ id: cfg.currentVariantId, quantity: 1 }];
    } else {
      items = tiles
        .filter(t => (state[t.dataset.variantId] || 0) > 0)
        .map(t => ({ id: parseInt(t.dataset.variantId, 10), quantity: state[t.dataset.variantId] }));
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if(!res.ok){
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart. Please try again.');
      }

      const cart = await fetch('/cart.js').then(r => r.json());
      let bubble = document.querySelector('.btn-icon__count');
      if(bubble){
        bubble.textContent = cart.item_count;
      } else if(cart.item_count > 0){
        // Cart was empty before this add — the span doesn't exist yet; create it.
        const cartLink = document.querySelector('.btn-icon[href*="/cart"]');
        if(cartLink){
          bubble = document.createElement('span');
          bubble.className = 'btn-icon__count';
          bubble.setAttribute('aria-hidden', 'true');
          bubble.textContent = cart.item_count;
          cartLink.appendChild(bubble);
        }
      }

      addBtnLabel.textContent = 'Added';
      setTimeout(() => { addBtnLabel.textContent = originalLabel; addBtn.disabled = false; }, 1200);
    } catch (err) {
      errorEl.textContent = err.message || 'Something went wrong adding this to your cart.';
      errorEl.hidden = false;
      addBtnLabel.textContent = originalLabel;
      addBtn.disabled = false;
    }
  });

  render();
});
  } catch(e) { console.error(e); }
})();

})();
